// @flow
import React from 'react';
import AbstractReactComponent from './../AbstractReactComponent';
import ApiObjectSuggestField from './../field/ApiObjectSuggestField';
import EaApi from './../api/EaApi';
import {COMPONENT_CHILDREN} from './../Utils2';

/**
 * Obec Field
 *
 * Obec Suggest field
 */
class ObecField extends AbstractReactComponent {

    static PropTypes = {
        addonsBefore: COMPONENT_CHILDREN,
        addonsAfter: COMPONENT_CHILDREN,
    };

    static defaultProps = {
        apiRequestDelay: 250,
    };

    handleFilterSuggestions = (value) => {
        if (value && value.length > 1) {    // hledáme až od dvou znaků!
            return EaApi.findObce(value);
        } else {
            return new Promise((resolve, reject) => {
                resolve([]);
            });
        }
    };

    render() {
        const {...other} = this.props;

        return <ApiObjectSuggestField
            minCharsForFilter={3}
            placeholder="Vyhledat obec..."
            removable
            filterSuggestions={this.handleFilterSuggestions}
            getItemValue={(item) => item ? (item.nazevObec + " (" + item.nazevOkres + ")") : ""}
            renderSuggestion={(i, active, getItemValue) => <div className={active ? "active" : ""}>{i.nazevObec + " (" + i.nazevOkres + ")"}</div>}
            {...other}
        />
    }
}

export default ObecField;
